import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions';
import { Switch, Route } from 'react-router-dom';
import { autobind, getLoadingDom } from '../utils';
import Header from '../presentation/Header';
import CreateMapping from './CreateMapping';
import SvgIcon from '../presentation/SvgIcon';
import CloseIcon from '../assets/images/svgs/close-x.svg';

@connect((state) => {
    return {
        uiState: state.uiState,
        userAccount: state.userAccount,
        emailEnterpriseMap: state.emailEnterpriseMap,
        enterprises: state.enterprises
    }
})
export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        autobind(['hideOverlay', 'showAddMapElement', 'addMapElement'], this);
    }

    componentDidMount() {
        this.props.dispatch({
            type: actions.GET_EMAIL_ENTERPRISE_MAP_REQUEST
        });
        this.props.dispatch({
            type: actions.GET_ENTERPRISES_REQUEST
        });
    }

    showAddMapElement() {
        this.props.dispatch({
            type: actions.SHOW_OVERLAY,
            overlayType: 'createmapping'
        });
    }

    addMapElement(mapElement) {
        const newMapList = [...this.props.emailEnterpriseMap.mapList, mapElement];
        this.props.dispatch({
            type: actions.SAVE_EMAIL_ENTERPRISE_MAP_REQUEST,
            mapList: newMapList
        });
    }

    removeMapElement(removeElement) {
        const newMapList = [...this.props.emailEnterpriseMap.mapList];
        const mapElementIndex = newMapList.findIndex((mapEl) => {
            return mapEl.email === removeElement.email;
        });
        if(mapElementIndex >= 0) {
            newMapList.splice(mapElementIndex, 1);
            this.props.dispatch({
                type: actions.SAVE_EMAIL_ENTERPRISE_MAP_REQUEST,
                mapList: newMapList
            });
        }
    }

    renderOverlay() {
        const overlayType = this.props.uiState.overlayType;
        const data = this.props.uiState.overlayData;
        const enterprises = this.props.enterprises;
        switch(overlayType) {
            case 'createmapping':
                return (<CreateMapping dispatch={this.props.dispatch} enterprises={enterprises} addMapElement={this.addMapElement}/>);
            default:
                return <div></div>;
        }
    }

    hideOverlay() {
        this.props.dispatch({
            type: actions.HIDE_OVERLAY
        });
    }

    showLoginInfo(enterpriseId){
      const enterprises = this.props.enterprises;
      var convo = enterprises.enterprisesList.filter(function ( obj ) {
        return obj._id === enterpriseId;
      })[0];
      return(
        <p>
          <span> {convo !== undefined && convo.admin_mail_id ? convo.admin_mail_id: ''}:</span>
          <span> {convo !== undefined && convo.admin_pwd ? convo.admin_pwd: ''} </span>
        </p>
      )
    }

    render() {
        const emailEnterpriseMap = this.props.emailEnterpriseMap;

        return (
            <div className="screen-container vflex jfs">
                <Header dispatch={this.props.dispatch} />
                <div className="title-add-container hflex jsb">
                    <div>
                      <h1 className="title">Email Enterprise Map</h1>
                      <a className="link" href="http://amygb-console.s3-website.ap-south-1.amazonaws.com/#/login">Email ERA console login url</a>
                    </div>
                    <button type="button" className="btn btn-primary add-map" onClick={this.showAddMapElement}>+ Add</button>
                </div>

                <div className="map-container">
                    {emailEnterpriseMap.fetching && getLoadingDom()}
                    {emailEnterpriseMap.fetchFailed && <p className="status-text">
                        Failed to load email enterprise map
                    </p>}
                    {emailEnterpriseMap.fetched &&
                        <ul className="map-list vflex jfs ast">
                        {
                            emailEnterpriseMap.mapList.map((mapElement, idx) => {
                                return (<li className="map-element hflex jfs" key={idx}>
                                    <span className="map-email">{mapElement.email}</span>:
                                    <span className="map-enterprise">{mapElement.enterpriseName}</span>
                                    <span className="map-enterprise">{mapElement.enterpriseId}</span>
                                    <span className="map-login">{this.showLoginInfo(mapElement.enterpriseId)}</span>
                                    <button type="button" className="btn btn-text remove-map-element" onClick={this.removeMapElement.bind(this, mapElement)}>
                                        <SvgIcon className="logo-image" glyph={CloseIcon} width='15px' height='15px'/>
                                    </button>
                                </li>)
                            })
                        }
                        </ul>
                    }
                </div>
                {this.props.uiState.showOverlay && (
                    <div className="overlay-container vflex">
                        <div className="overlay-background"></div>
                        <div className={"overlay-content " + this.props.uiState.overlayType}>
                            {this.renderOverlay()}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js